<template>
  <div class="abstract-card" v-if="form != undefined">
    <div class="header">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractSubmission.submission')}} <el-switch v-model="form.enableSubmissionTopics"></el-switch></div>
      <span>{{$t('components.abstract.tabs.abstractSubmission.submissionMsg')}}</span>
    </div>
    <transition name="el-fade-in">
      <div v-show="form.enableSubmissionTopics">
        <div class="registerform-input-container mt-2">
          <div class="title">
            <div>
              <label>{{$t('components.abstract.tabs.abstractSubmission.title')}}</label>
              <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </div>
          <el-input v-model="form.submissionTopicsTitle"></el-input>
          <span class="error">{{ $errorMessage('submissionTopicsTitle', validationErrors) }}</span>
        </div>
        <div class="custom-grid-table-header abstract-submission-header mt-2" v-if="form.topics && form.topics.length > 0">
          <div></div>
          <div>{{$t('components.abstract.tabs.abstractSubmission.topicsTracks')}}</div>
          <div></div>
        </div>
        <draggable class="abstract-submission-container" handle=".el-icon-s-grid" :options="dragOptions">
          <div class="item" v-for="(topic, topicIndex) in form.topics" :key="topicIndex">
            <i class="burger el-icon-s-grid"></i>
            <div><el-input v-model="topic.title" :class="$inputError('topics['+topicIndex+'].Title',validationErrors)"></el-input></div>
            <div class="d-flex justify-content-end">
              <el-button size="mini" type="primary" icon="fas fa-pen" @click="editSubmission(topic, topicIndex)" circle></el-button>
              <el-button size="mini" type="danger" icon="fas fa-trash" circle @click="form.topics.splice(topicIndex, 1)"></el-button>
            </div>
          </div>
        </draggable>
        <div class="d-flex mt-2  justify-content-end">
          <el-button-group>
            <el-button size="mini" type="default" icon="el-icon-refresh" round></el-button>
            <el-button size="mini" type="primary" icon="fas fa-plus" round @click="addTopics">{{$t('components.abstract.tabs.abstractSubmission.addTopicTrack')}}</el-button>
          </el-button-group>
        </div>
      </div>
    </transition>

    <div class="header mt-3">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractSubmission.presentationType')}} <el-switch v-model="form.enablePresentationTypes"></el-switch></div>
      <span>{{$t('components.abstract.tabs.abstractSubmission.presentationTypeMsg')}}</span>
    </div>
    <transition name="el-fade-in">
      <div v-show="form.enablePresentationTypes">
        <div class="registerform-input-container mt-2">
          <div class="title">
            <div>
              <label>{{$t('components.abstract.tabs.abstractSubmission.title')}}</label>
              <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </div>
          <el-input v-model="form.presentationTypesTitle" ></el-input>
          <span class="error">{{ $errorMessage('presentationTypesTitle', validationErrors) }}</span>
        </div>
        <div class="custom-grid-table-header abstract-submission-type-header mt-2" v-if="form.presentationTypes && form.presentationTypes.length > 0">
          <div></div>
          <div>{{$t('components.abstract.tabs.abstractSubmission.presentationType')}}</div>
          <div class="text-center">{{$t('components.abstract.tabs.abstractSubmission.show')}}</div>
          <div></div>
        </div>
        <draggable class="abstract-submission-type-container" handle=".el-icon-s-grid" :options="dragOptions">
          <div class="item" v-for="(presentationType, presentationTypeIndex) in form.presentationTypes" :class="{ passive: !presentationType.isActive }" :key="presentationTypeIndex">
            <i class="burger el-icon-s-grid"></i>
            <div><el-input v-model="presentationType.title" :class="$inputError('presentationTypes['+presentationTypeIndex+'].Title',validationErrors)"></el-input></div>
            <div class="text-center">
              <el-switch v-model="presentationType.isActive" ></el-switch>
            </div>
            <div class="d-flex justify-content-end">
              <el-button size="mini" type="primary" icon="fas fa-pen" @click="editPresentationType(presentationType, presentationTypeIndex)" circle></el-button>
              <el-button size="mini" type="danger" icon="fas fa-trash" circle @click="form.presentationTypes.splice(presentationTypeIndex, 1)"></el-button>
            </div>
          </div>
        </draggable>
        <div class="d-flex mt-2 justify-content-end">
          <el-button-group>
            <el-button size="mini" type="default" icon="el-icon-refresh" round></el-button>
            <el-button size="mini" type="primary" icon="fas fa-plus" round @click="addPresentationType">{{$t('components.abstract.tabs.abstractSubmission.addPresentationType')}}</el-button>
          </el-button-group>
        </div>
      </div >
    </transition>

    <el-dialog :visible.sync="submissionVisible" width="30%" :title="$t('components.abstract.tabs.abstractSubmission.topicTrackDetails')" append-to-body center>
      <SubmissionDialog v-if="submissionVisible" :data="submissionForm" @closeMe="submissionVisible = false" @deleteMe="deleteSubmission" @updated="updateSubmission" />
    </el-dialog>

    <el-dialog :visible.sync="presentationTypeVisible" width="30%" :title="$t('components.abstract.tabs.abstractSubmission.presentationTypesDetails')" append-to-body center>
      <PresentationType v-if="presentationTypeVisible" :data="presentationTypeForm" @closeMe="presentationTypeVisible = false" @deleteMe="deletePresentationType" @updated="updatePresentationType" />
    </el-dialog>

    <div class="bottom mt-3 d-flex justify-content-end">
      <el-button type="primary" size="mini" round :loading="loading" @click="saveAbstractSubmission">{{$t('components.abstract.tabs.abstractSubmission.save')}}</el-button>
    </div>
  </div>
</template>

<script>
import SubmissionDialog from './dialog/SubmissionDialog.vue';
import PresentationType from './dialog/PresentationType.vue';
import draggable from 'vuedraggable';
export default {
  components: {
    draggable,
    SubmissionDialog,
    PresentationType,
  },
  props: ['data'],
  data() {
    return {
      submissionVisible: false,
      submissionForm: null,
      submissionIndex: null,
      presentationTypeVisible: false,
      presentationTypeForm: null,
      presentationTypeIndex: null,
      validationErrors: [],
      form: {},
      loading: false,
      timeout: null,
    };
  },
  async beforeMount() {
    this.form = this.data;
  },
  methods: {
    async saveAbstractSubmission() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = true;
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch('abstractUpdateTopics', this.form);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    deleteSubmission() {
      this.form.topics.splice(this.submissionIndex, 1);
      this.submissionVisible = false;
    },
    updateSubmission(item) {
      this.form.topics.splice(this.submissionIndex, 1, item);
      this.submissionVisible = false;
    },
    editSubmission(item, index) {
      this.submissionForm = JSON.parse(JSON.stringify(item));
      this.submissionIndex = index;
      this.submissionVisible = true;
    },
    deletePresentationType() {
      this.form.presentationTypes.splice(this.presentationTypeIndex, 1);
      this.presentationTypeVisible = false;
    },
    updatePresentationType(item) {
      this.form.presentationTypes.splice(this.presentationTypeIndex, 1, item);
      this.presentationTypeVisible = false;
    },
    editPresentationType(item, index) {
      this.presentationTypeForm = JSON.parse(JSON.stringify(item));
      this.presentationTypeIndex = index;
      this.presentationTypeVisible = true;
    },
    addTopics() {
      this.form.topics.push({
        id: null,
        title: 'New Topic / Track ' + (this.form.topics.length + 1),
        details: null,
      });
    },
    addPresentationType() {
      this.form.presentationTypes.push({
        id: null,
        title: 'Type like Oral, Poster, Panel Discussion, etc.',
        details: null,
        isActive: false,
      });
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  watch: {
    data() {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.abstract-card {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 1rem;
  & > .header {
    color: black;
    & > .title {
      display: flex;
      font-weight: bold;
      justify-content: space-between;
      align-items: center;
    }
    span {
      font-weight: 400;
    }
  }
}
.abstract-submission-header {
  grid-template-columns: 36px 1fr 80px;
}
.abstract-submission-type-header {
  grid-template-columns: 36px 1fr 90px 80px;
}
.abstract-submission-type-container {
  .item {
    &.passive {
      background-color: #fff2f2 !important;
    }

    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
    }
    gap: 0.5rem;
    padding: 1rem;
    margin-bottom: 8px;
    background-color: #f1f1f1;
    border-radius: 8px;
    display: grid;
    grid-template-columns: 36px 1fr 90px 80px;
    align-items: center;
    & > i.el-icon-loading {
      font-size: 20px;
    }
  }
}
.abstract-submission-container {
  .item {
    &.passive {
      background-color: #fff2f2 !important;
    }

    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
    }
    gap: 0.5rem;
    padding: 1rem;
    margin-bottom: 8px;
    background-color: #f1f1f1;
    border-radius: 8px;
    display: grid;
    grid-template-columns: 36px 1fr 80px;
    align-items: center;
    & > i.el-icon-loading {
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/AbstractSubmission.vue